import { render, staticRenderFns } from "./AreaSetupPage.vue?vue&type=template&id=b249e39e"
import script from "./AreaSetupPage.vue?vue&type=script&lang=ts"
export * from "./AreaSetupPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports